import {on} from 'delegated-events'
import {remoteForm} from '@github-ui/remote-form'

function markAsRead(notification: Element): void {
  if (!notification.classList.contains('unread')) return
  notification.classList.remove('unread')
  notification.classList.add('read')
}

// Ensure notifications are marked as read after opening.
on('navigation:keyopen', '.js-notification', function (event) {
  markAsRead(event.currentTarget)
})

// Subscription landing page spinner
remoteForm('.js-notifications-subscription', async function (form, wants) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const spinner = form.querySelector<HTMLElement>('.js-spinner')!
  /* eslint-disable-next-line github/no-d-none */
  spinner.classList.remove('d-none')
  try {
    await wants.html()
  } catch {
    // Ignore any error
  }
  /* eslint-disable-next-line github/no-d-none */
  spinner.classList.add('d-none')
})

on('change', '.js-notification-subscriptions-check', function () {
  const subscriptionChecked = document.querySelector('.js-notification-subscriptions-check:checked') != null
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLElement>('.js-notification-subscription-filters')!.hidden = subscriptionChecked
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLElement>('.js-notification-subscription-actions')!.hidden = !subscriptionChecked
})
